import { render, staticRenderFns } from "./Guesslot.vue?vue&type=template&id=4efe25ee&scoped=true&"
import script from "./Guesslot.vue?vue&type=script&lang=js&"
export * from "./Guesslot.vue?vue&type=script&lang=js&"
import style0 from "./Guesslot.vue?vue&type=style&index=0&id=4efe25ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe25ee",
  null
  
)

export default component.exports